var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#F3AF47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5769 3.1728C8.76527 2.85386 9.2362 2.85386 9.42457 3.1728L14.9344 12.5017C15.1228 12.8206 14.8873 13.2193 14.5106 13.2193H3.49087C3.11412 13.2193 2.87866 12.8206 3.06703 12.5017L8.5769 3.1728Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31523 9.75522H8.70352L8.5207 6.14624H9.49453L9.31523 9.75522ZM8.47852 10.8861C8.47852 10.7112 8.52422 10.5789 8.61563 10.4891C8.70703 10.3969 8.83711 10.3508 9.00586 10.3508C9.17227 10.3508 9.3 10.3981 9.38906 10.4926C9.47813 10.5872 9.52266 10.7183 9.52266 10.8861C9.52266 11.0539 9.47695 11.1875 9.38555 11.2867C9.29648 11.3836 9.16992 11.4321 9.00586 11.4321C8.83945 11.4321 8.70938 11.3848 8.61563 11.2903C8.52422 11.1957 8.47852 11.061 8.47852 10.8861Z",
    fill: "#F3AF47"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/noData_icon.ebae7938999162620af8a4c77408c445.svg";
export { ForwardRef as ReactComponent };